import * as Yup from 'yup';

export const dealCalculatorFormSchema = Yup.object().shape({});
